/**
 * useTradeHistory — Fetches recent swap history for a token.
 *
 * Story 4.1: Token Detail API hooks
 */

import { useQuery } from "@tanstack/react-query";
import { tokensApi } from "../../lib/api";
import { tokenKeys } from "./query-keys";

export function useTradeHistory(id: string, limit?: number) {
	return useQuery({
		queryKey: tokenKeys.trades(id),
		queryFn: async () => {
			const response = await tokensApi.getTrades(id, limit);
			return response.data;
		},
		enabled: !!id,
		staleTime: 15_000,
	});
}
